/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-surface-pick-up/dist/index.es.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var LOCAL_STORAGE_KEY = 'pxu-shopify-surface-pick-up';
var loadingClass = 'surface-pick-up--loading';

var isNotExpired = function isNotExpired(timestamp) {
  return timestamp + 1000 * 60 * 60 >= Date.now();
};

var removeTrailingSlash = function removeTrailingSlash(s) {
  return s.replace(/(.*)\/$/, '$1');
}; // Haversine Distance
// The haversine formula is an equation giving great-circle distances between
// two points on a sphere from their longitudes and latitudes


function calculateDistance(latitude1, longitude1, latitude2, longitude2, unitSystem) {
  var dtor = Math.PI / 180;
  var radius = unitSystem === 'metric' ? 6378.14 : 3959;
  var rlat1 = latitude1 * dtor;
  var rlong1 = longitude1 * dtor;
  var rlat2 = latitude2 * dtor;
  var rlong2 = longitude2 * dtor;
  var dlon = rlong1 - rlong2;
  var dlat = rlat1 - rlat2;
  var a = Math.pow(Math.sin(dlat / 2), 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return radius * c;
}

function getGeoLocation() {
  return _getGeoLocation.apply(this, arguments);
}

function _getGeoLocation() {
  _getGeoLocation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var options = {
                maximumAge: 3600000,
                // 1 hour
                timeout: 5000
              };

              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (_ref3) {
                  var coords = _ref3.coords;
                  return resolve(coords);
                }, reject, options);
              } else {
                reject();
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getGeoLocation.apply(this, arguments);
}

function setLocation(_x) {
  return _setLocation.apply(this, arguments);
}

function _setLocation() {
  _setLocation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref) {
    var latitude, longitude, newData;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            latitude = _ref.latitude, longitude = _ref.longitude;
            newData = {
              latitude: latitude,
              longitude: longitude,
              timestamp: Date.now()
            };
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newData));
            return _context2.abrupt("return", fetch('/localization.json', {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                latitude: latitude,
                longitude: longitude
              })
            }).then(function () {
              return {
                latitude: latitude,
                longitude: longitude
              };
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _setLocation.apply(this, arguments);
}

function getLocation() {
  return _getLocation.apply(this, arguments);
}

function _getLocation() {
  _getLocation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var requestLocation,
        cachedLocation,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            requestLocation = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
            cachedLocation = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));

            if (!(cachedLocation && isNotExpired(cachedLocation.timestamp))) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", cachedLocation);

          case 4:
            if (!requestLocation) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", getGeoLocation().then(function (coords) {
              setLocation(coords); // We don't need to wait for this

              return coords;
            }));

          case 6:
            return _context3.abrupt("return", null);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getLocation.apply(this, arguments);
}

var SurfacePickUp = /*#__PURE__*/function () {
  function SurfacePickUp(el, options) {
    _classCallCheck(this, SurfacePickUp);

    this.el = el;
    this.options = _objectSpread2({
      root_url: window.Theme && window.Theme.routes && window.Theme.routes.root_url || ''
    }, options);
    this.options.root_url = removeTrailingSlash(this.options.root_url);
    this.callbacks = [];
    this.onBtnPress = null;
    this.latestVariantId = null;
  }

  _createClass(SurfacePickUp, [{
    key: "load",
    value: function load(variantId) {
      var _this = this;

      // If no variant is available, empty element and quick-return
      if (!variantId) {
        this.el.innerHTML = '';
        return Promise.resolve(true);
      } // Because Shopify doesn't expose any `pick_up_enabled` data on the shop object, we
      // don't know if the variant might be, or is definitely not available for pick up.
      // Until we know the shop has > 0 pick up locations, we want to avoid prompting the
      // user for location data (it's annoying, and only makes sense to do if we use it).
      //
      // Instead, we have to make an initial request, check and see if any pick up locations
      // were returned, then ask for the users location, then make another request to get the
      // location-aware pick up locations.
      //
      // As far as I can tell the pick up aware locations differ only in sort order - which
      // we could do on the front end - but we're following this approach to ensure future
      // compatibility with any changes Shopify makes (maybe disabling options based on
      // user location, or whatever else).
      //
      // Shopify has indicated they will look into adding pick_up_enabled data to the shop
      // object, which which case this method can be greatly simplifed into 2 simple cases.


      this.latestVariantId = variantId;
      this.el.classList.add(loadingClass);
      return this._getData(variantId).then(function (data) {
        return _this._injectData(data);
      });
    }
  }, {
    key: "onModalRequest",
    value: function onModalRequest(callback) {
      if (this.callbacks.indexOf(callback) >= 0) return;
      this.callbacks.push(callback);
    }
  }, {
    key: "offModalRequest",
    value: function offModalRequest(callback) {
      this.callbacks.splice(this.callbacks.indexOf(callback));
    }
  }, {
    key: "unload",
    value: function unload() {
      this.callbacks = [];
      this.el.innerHTML = '';
    }
  }, {
    key: "_getData",
    value: function _getData(variantId) {
      var _this2 = this;

      return new Promise(function (resolve) {
        var xhr = new XMLHttpRequest();
        var requestUrl = "".concat(_this2.options.root_url, "/variants/").concat(variantId, "/?section_id=surface-pick-up");
        xhr.open('GET', requestUrl, true);

        xhr.onload = function () {
          var el = xhr.response;
          var embed = el.querySelector('[data-html="surface-pick-up-embed"]');
          var itemsContainer = el.querySelector('[data-html="surface-pick-up-items"]');
          var items = itemsContainer.content.querySelectorAll('[data-surface-pick-up-item]');
          resolve({
            embed: embed,
            itemsContainer: itemsContainer,
            items: items,
            variantId: variantId
          });
        };

        xhr.onerror = function () {
          resolve({
            embed: {
              innerHTML: ''
            },
            itemsContainer: {
              innerHTML: ''
            },
            items: [],
            variantId: variantId
          });
        };

        xhr.responseType = 'document';
        xhr.send();
      });
    }
  }, {
    key: "_injectData",
    value: function _injectData(_ref2) {
      var _this3 = this;

      var embed = _ref2.embed,
          itemsContainer = _ref2.itemsContainer,
          items = _ref2.items,
          variantId = _ref2.variantId;

      if (variantId !== this.latestVariantId || items.length === 0) {
        this.el.innerHTML = '';
        this.el.classList.remove(loadingClass);
        return;
      }

      this.el.innerHTML = embed.innerHTML;
      this.el.classList.remove(loadingClass);
      var calculatedDistances = false;

      var calculateDistances = function calculateDistances() {
        if (calculatedDistances) return Promise.resolve();
        return getLocation(true).then(function (coords) {
          items.forEach(function (item) {
            var distanceEl = item.querySelector('[data-distance]');
            var distanceUnitEl = item.querySelector('[data-distance-unit]');
            var unitSystem = distanceUnitEl.dataset.distanceUnit;
            var itemLatitude = parseFloat(distanceEl.dataset.latitude);
            var itemLongitude = parseFloat(distanceEl.dataset.longitude);

            if (coords && isFinite(itemLatitude) && isFinite(itemLongitude)) {
              var distance = calculateDistance(coords.latitude, coords.longitude, itemLatitude, itemLongitude, unitSystem);
              distanceEl.innerHTML = distance.toFixed(1);
            } else {
              distanceEl.remove();
              distanceUnitEl.remove();
            }
          });
        })["catch"](function (e) {
          
          items.forEach(function (item) {
            var distanceEl = item.querySelector('[data-distance]');
            var distanceUnitEl = item.querySelector('[data-distance-unit]');
            distanceEl.remove();
            distanceUnitEl.remove();
          });
        })["finally"](function () {
          calculatedDistances = true;
        });
      };

      this.el.querySelector('[data-surface-pick-up-embed-modal-btn]').addEventListener('click', function () {
        calculateDistances().then(function () {
          return _this3.callbacks.forEach(function (callback) {
            return callback(itemsContainer.innerHTML);
          });
        });
      });
    }
  }]);

  return SurfacePickUp;
}();

/* harmony default export */ const index_es = (SurfacePickUp);

;// CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-price-ui/dist/index.es.js
function index_es_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function index_es_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function index_es_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) index_es_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) index_es_defineProperties(Constructor, staticProps);
  return Constructor;
}

function index_es_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function index_es_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function index_es_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      index_es_ownKeys(Object(source), true).forEach(function (key) {
        index_es_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      index_es_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var priceUITemplate = document.getElementById('price-ui').content;
var priceTemplate = document.getElementById('price-ui__price').content;
var priceRangeTemplate = document.getElementById('price-ui__price-range').content;
var unitPriceTemplate = document.getElementById('price-ui__unit-pricing').content;

function createPriceRangeFragment(priceMin, priceMax, formatter) {
  var priceRangeFragment = priceRangeTemplate.cloneNode(true);
  priceRangeFragment.querySelector('[data-price-min] [data-price]').innerHTML = formatter(priceMin);
  priceRangeFragment.querySelector('[data-price-max] [data-price]').innerHTML = formatter(priceMax);
  return priceRangeFragment;
}

function createPriceFragment(price, formatter) {
  var priceFragment = priceTemplate.cloneNode(true);
  priceFragment.querySelector('[data-price]').innerHTML = formatter(price);
  return priceFragment;
}

function createUnitPricing(variant, formatter) {
  var unitPriceContainer = unitPriceTemplate.cloneNode(true);
  var unitQuantityEl = unitPriceContainer.querySelector('[data-unit-quantity]');
  var unitPriceEl = unitPriceContainer.querySelector('[data-unit-price] [data-price]');
  var unitMeasurementEl = unitPriceContainer.querySelector('[data-unit-measurement]');
  unitQuantityEl.innerHTML = "".concat(variant.unit_price_measurement.quantity_value).concat(variant.unit_price_measurement.quantity_unit);
  unitPriceEl.innerHTML = formatter(variant.unit_price);

  if (variant.unit_price_measurement.reference_value === 1) {
    unitMeasurementEl.innerHTML = variant.unit_price_measurement.reference_unit;
  } else {
    unitMeasurementEl.innerHTML = "".concat(variant.unit_price_measurement.reference_value).concat(variant.unit_price_measurement.reference_unit);
  }

  return unitPriceContainer;
}

var PriceUI = /*#__PURE__*/function () {
  function PriceUI(el) {
    index_es_classCallCheck(this, PriceUI);

    this._el = el;
  }

  index_es_createClass(PriceUI, [{
    key: "load",
    value: function load(product, options) {
      var _variant$formatter$ha = index_es_objectSpread2({
        variant: false,
        formatter: function formatter(price) {
          return price;
        },
        handler: function handler(priceUIFragment) {
          return priceUIFragment;
        }
      }, options),
          variant = _variant$formatter$ha.variant,
          formatter = _variant$formatter$ha.formatter,
          handler = _variant$formatter$ha.handler;

      this._el.classList.add('price-ui--loading');

      var priceUIFragment = handler(!variant ? this._loadProduct(product, formatter) : this._loadVariant(variant, formatter), product, options);

      this._el.innerHTML = '';

      this._el.appendChild(priceUIFragment);
      this._el.setAttribute('data-variant-id', variant.id);

      this._el.classList.remove('price-ui--loading');
    }
  }, {
    key: "_loadVariant",
    value: function _loadVariant(variant, formatter) {
      var priceUIFragment = priceUITemplate.cloneNode(true);
      var compareAtPriceEl = priceUIFragment.querySelector('[data-compare-at-price]');
      var priceEl = priceUIFragment.querySelector('[data-price]');
      var unitPricingEl = priceUIFragment.querySelector('[data-unit-pricing]');
      var isOnSale = variant.compare_at_price && variant.compare_at_price !== variant.price;

      if (isOnSale) {
        priceEl.classList.add('price--sale');

        var _priceFragment = createPriceFragment(variant.compare_at_price, formatter);

        compareAtPriceEl.appendChild(_priceFragment);
      }

      var priceFragment = createPriceFragment(variant.price, formatter);
      priceEl.appendChild(priceFragment);
      priceEl.setAttribute('data-variant-id', variant.id);

      if ('unit_price' in variant) {
        var unitPricingFragment = createUnitPricing(variant, formatter);
        unitPricingEl.appendChild(unitPricingFragment);
      }

      return priceUIFragment;
    }
  }, {
    key: "_loadProduct",
    value: function _loadProduct(product, formatter) {
      var priceMin = null;
      var priceMax = null;
      var compareAtPriceMin = null;
      var compareAtPriceMax = null;
      var priceVaries = false;
      var compareAtPriceVaries = false;
      var isOnSale = false;
      product.variants.forEach(function (variant) {
        // Use variant price as compare_at_price if compare_at_price is unavailable

        // variant.compare_at_price = variant.price*1.5;
        
        var tmpCompareAtPrice = variant.compare_at_price ? variant.compare_at_price : variant.price; // Determine price min

        if (priceMin === null || variant.price < priceMin) {
          priceMin = variant.price;
        } // Determine price max


        if (priceMax === null || variant.price > priceMax) {
          priceMax = variant.price;
        } // Determine compare_at_price min


        if (compareAtPriceMin === null || tmpCompareAtPrice < compareAtPriceMin) {
          compareAtPriceMin = tmpCompareAtPrice;
        } // Determine compare_at_price max


        if (compareAtPriceMax === null || tmpCompareAtPrice > compareAtPriceMax) {
          compareAtPriceMax = tmpCompareAtPrice;
        }

        if (tmpCompareAtPrice !== variant.price) {
          isOnSale = true;
        }
      });
      priceVaries = priceMin !== priceMax;
      compareAtPriceVaries = compareAtPriceMin !== compareAtPriceMax;
      var priceUIFragment = priceUITemplate.cloneNode(true);
      var compareAtPriceEl = priceUIFragment.querySelector('[data-compare-at-price]');
      var priceEl = priceUIFragment.querySelector('[data-price]');

      if (isOnSale) {
        priceEl.classList.add('price--sale');

        if (compareAtPriceVaries) {
          var priceRangeFragment = createPriceRangeFragment(compareAtPriceMin, compareAtPriceMax, formatter);
          compareAtPriceEl.appendChild(priceRangeFragment);
        } else {
          var priceFragment = createPriceFragment(compareAtPriceMin, formatter);
          compareAtPriceEl.appendChild(priceFragment);
        }
      }

      if (priceVaries) {
        var _priceRangeFragment = createPriceRangeFragment(priceMin, priceMax, formatter);

        priceEl.appendChild(_priceRangeFragment);
      } else {
        var _priceFragment2 = createPriceFragment(priceMin, formatter);

        priceEl.appendChild(_priceFragment2);
        priceEl.setAttribute('data-variant-id', product.variants[0].id);
      }

      return priceUIFragment;
    }
  }]);

  return PriceUI;
}();

var priceUIBadgeTemplate = document.getElementById('price-ui-badge').content;
var badgePercentSavingsTemplate = document.getElementById('price-ui-badge__percent-savings').content;
var badgePercentSavingsRangeTemplate = document.getElementById('price-ui-badge__percent-savings-range').content;
var badgeSavingsTemplate = document.getElementById('price-ui-badge__price-savings').content;
var badgeSavingsRangeTemplate = document.getElementById('price-ui-badge__price-savings-range').content;
var badgeOnSaleTemplate = document.getElementById('price-ui-badge__on-sale').content;
var badgeSoldOutTemplate = document.getElementById('price-ui-badge__sold-out').content;
var badgeInStockTemplate = document.getElementById('price-ui-badge__in-stock').content;

function createBadgeRangeFragment(savings, percent, style, formatter) {
  var badgeRangeFragment = null;

  switch (style) {
    case 'percent':
      badgeRangeFragment = badgePercentSavingsRangeTemplate.cloneNode(true);
      badgeRangeFragment.querySelector('[data-price-percent]').innerHTML = percent;
      break;

    case 'money':
      badgeRangeFragment = badgeSavingsRangeTemplate.cloneNode(true);
      badgeRangeFragment.querySelector('[data-price]').innerHTML = formatter(savings);
      break;

    default:
      badgeRangeFragment = badgeOnSaleTemplate.cloneNode(true);
      break;
  }

  return badgeRangeFragment;
}

function createBadgeSingleFragment(savings, percent, style, formatter) {
  var badgeSingleFragment = null;

  switch (style) {
    case 'percent':
      badgeSingleFragment = badgePercentSavingsTemplate.cloneNode(true);
      badgeSingleFragment.querySelector('[data-price-percent]').innerHTML = percent;
      break;

    case 'money':
      badgeSingleFragment = badgeSavingsTemplate.cloneNode(true);
      badgeSingleFragment.querySelector('[data-price]').innerHTML = formatter(savings);
      break;

    default:
      badgeSingleFragment = badgeOnSaleTemplate.cloneNode(true);
      break;
  }

  return badgeSingleFragment;
}

var PriceUIBadge = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function PriceUIBadge(el) {
    index_es_classCallCheck(this, PriceUIBadge);

    this._el = el;
  }

  index_es_createClass(PriceUIBadge, [{
    key: "load",
    value: function load(product, options) {
      var _variant$style$format = index_es_objectSpread2({
        variant: false,
        style: 'percent',
        formatter: function formatter(price) {
          return price;
        },
        handler: function handler(priceUIFragment) {
          return priceUIFragment;
        }
      }, options),
          variant = _variant$style$format.variant,
          style = _variant$style$format.style,
          formatter = _variant$style$format.formatter,
          handler = _variant$style$format.handler;

      this._el.classList.add('price-ui-badge--loading');

      var priceUIBadgeFragment = handler(!variant ? this._loadProduct(product, style, formatter) : this._loadVariant(variant, style, formatter), product, options);
      this._el.innerHTML = '';

      this._el.appendChild(priceUIBadgeFragment);

      this._el.classList.remove('price-ui-badge--loading');
    }
  }, {
    key: "_loadVariant",
    value: function _loadVariant(variant, style, formatter) {
      var priceUIBadgeFragment = priceUIBadgeTemplate.cloneNode(true);
      var badgeEl = priceUIBadgeFragment.querySelector('[data-badge]');
      var isOnSale = variant.compare_at_price && variant.compare_at_price !== variant.price;

      if (!isOnSale) {
        var badgeInStockFragment = badgeInStockTemplate.cloneNode(true);
        badgeEl.appendChild(badgeInStockFragment);
        return priceUIBadgeFragment; // Fast return if it's not on sale
      }

      if (!variant.available) {
        var badgeSoldOutFragment = badgeSoldOutTemplate.cloneNode(true);
        badgeEl.appendChild(badgeSoldOutFragment);
      } else {
        var savings = variant.compare_at_price - variant.price; // Round percent to two decimal places

        var percent = Math.round(savings / variant.compare_at_price * 100);
        var badgeSingleFragment = createBadgeSingleFragment(savings, percent, style, formatter);
        badgeEl.appendChild(badgeSingleFragment);
      }

      return priceUIBadgeFragment;
    }
  }, {
    key: "_loadProduct",
    value: function _loadProduct(product, style, formatter) {
      var isOnSale = false;
      var savingsVaries = false;
      var largestSavings = -1;
      var largestPercentSavings = 0;
      product.variants.forEach(function (variant) {
        var tmpCompareAtPrice = variant.compare_at_price;

        if (!variant.compare_at_price) {
          tmpCompareAtPrice = variant.price;
        }

        var tmpSavings = tmpCompareAtPrice - variant.price;

        if (largestSavings !== 0 && tmpSavings !== largestSavings) {
          savingsVaries = true;
        }

        if (tmpSavings > 0) {
          isOnSale = true;

          if (tmpSavings > largestSavings) {
            largestSavings = tmpSavings;
            largestPercentSavings = tmpSavings / tmpCompareAtPrice;
          }
        }
      }); // Converts from a number out of 1, to a number out of 100 rounded to two decimals

      largestPercentSavings = Math.round(largestPercentSavings * 100);
      
      var priceUIBadgeFragment = priceUIBadgeTemplate.cloneNode(true);
      var badgeEl = priceUIBadgeFragment.querySelector('[data-badge]');

      if (!isOnSale) {
        var badgeInStockFragment = badgeInStockTemplate.cloneNode(true);
        badgeEl.appendChild(badgeInStockFragment);
        return priceUIBadgeFragment; // Fast return if it's not on sale
      }

      if (savingsVaries) {
        var badgeRangeFragment = createBadgeRangeFragment(largestSavings, largestPercentSavings, style, formatter);
        badgeEl.appendChild(badgeRangeFragment);
      } else {
        var badgeSingleFragment = createBadgeSingleFragment(largestSavings, largestPercentSavings, style, formatter);
        badgeEl.appendChild(badgeSingleFragment);
      }

      return priceUIBadgeFragment;
    }
  }]);

  return PriceUIBadge;
}()));



;// CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-asyncview/dist/index.es.js

  /*!
   * @pixelunion/shopify-asyncview v2.0.5
   * (c) 2020 Pixel Union
  */

function dist_index_es_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function dist_index_es_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function dist_index_es_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) dist_index_es_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) dist_index_es_defineProperties(Constructor, staticProps);
  return Constructor;
}

function dist_index_es_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function dist_index_es_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function dist_index_es_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      dist_index_es_ownKeys(Object(source), true).forEach(function (key) {
        dist_index_es_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      dist_index_es_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var deferred = {};

var AsyncView = /*#__PURE__*/function () {
  function AsyncView() {
    dist_index_es_classCallCheck(this, AsyncView);
  }

  dist_index_es_createClass(AsyncView, null, [{
    key: "load",

    /**
     * Load the template given by the provided URL into the provided
     * view
     *
     * @param {string} url - The url to load
     * @param {object} query - An object containing additional query parameters of the URL
     * @param {string} query.view - A required query parameter indicating which view to load
     * @param {object} [options] - Config options
     * @param {string} [options.hash] - A hash of the current page content
     */
    value: function load(url) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (!('view' in query)) {
        return Promise.reject(new Error('\'view\' not found in \'query\' parameter'));
      }

      var querylessUrl = url.replace(/\?[^#]+/, '');
      var queryParamsString = new RegExp(/.+\?([^#]+)/).exec(url);
      var queryParams = query;

      if (queryParamsString && queryParamsString.length >= 2) {
        queryParamsString[1].split('&').forEach(function (param) {
          var _param$split = param.split('='),
              _param$split2 = _slicedToArray(_param$split, 2),
              key = _param$split2[0],
              value = _param$split2[1];

          queryParams[key] = value;
        });
      } // NOTE: We're adding an additional timestamp to the query.
      // This is to prevent certain browsers from returning cached
      // versions of the url we are requesting.
      // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4


      var cachebustingParams = dist_index_es_objectSpread2({}, queryParams, {
        _: new Date().getTime()
      });

      var hashUrl = querylessUrl.replace(/([^#]+)(.*)/, function (match, address, hash) {
        return "".concat(address, "?").concat(Object.keys(queryParams).sort().map(function (key) {
          return "".concat(key, "=").concat(encodeURIComponent(queryParams[key]));
        }).join('&')).concat(hash);
      });
      var requestUrl = querylessUrl.replace(/([^#]+)(.*)/, function (match, address, hash) {
        return "".concat(address, "?").concat(Object.keys(cachebustingParams).sort().map(function (key) {
          return "".concat(key, "=").concat(encodeURIComponent(cachebustingParams[key]));
        }).join('&')).concat(hash);
      });
      var promise = new Promise(function (resolve, reject) {
        var data;

        if (hashUrl in deferred) {
          resolve(deferred[hashUrl]);
          return;
        }

        deferred[hashUrl] = promise;

        if (options.hash) {
          data = sessionStorage.getItem(hashUrl);

          if (data) {
            var deserialized = JSON.parse(data);

            if (options.hash === deserialized.options.hash) {
              delete deferred[hashUrl];
              resolve(deserialized);
              return;
            }
          }
        }

        var xhr = new XMLHttpRequest();
        xhr.open('GET', requestUrl, true);

        xhr.onload = function () {
          var el = xhr.response;
          var newOptions = {};
          var optionsEl = el.querySelector('[data-options]');

          if (optionsEl && optionsEl.innerHTML) {
            newOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
          }

          var htmlEls = el.querySelectorAll('[data-html]');
          var newHtml = {};

          if (htmlEls.length === 1 && htmlEls[0].getAttribute('data-html') === '') {
            newHtml = htmlEls[0].innerHTML;
          } else {
            for (var i = 0; i < htmlEls.length; i++) {
              newHtml[htmlEls[i].getAttribute('data-html')] = htmlEls[i].innerHTML;
            }
          }

          var dataEls = el.querySelectorAll('[data-data]');
          var newData = {};

          if (dataEls.length === 1 && dataEls[0].getAttribute('data-data') === '') {
            newData = JSON.parse(dataEls[0].innerHTML);
          } else {
            for (var _i = 0; _i < dataEls.length; _i++) {
              newData[dataEls[_i].getAttribute('data-data')] = JSON.parse(dataEls[_i].innerHTML);
            }
          }

          if (options.hash) {
            try {
              sessionStorage.setItem(hashUrl, JSON.stringify({
                options: newOptions,
                data: newData,
                html: newHtml
              }));
            } catch (error) {
              console.error(error);
            }
          }

          delete deferred[hashUrl];
          resolve({
            data: newData,
            html: newHtml
          });
        };

        xhr.onerror = function () {
          delete deferred[hashUrl];
          reject();
        };

        xhr.responseType = 'document';
        xhr.send();
      });
      return promise;
    }
  }]);

  return AsyncView;
}();

/* harmony default export */ const dist_index_es = (AsyncView);

;// CONCATENATED MODULE: ./source/scripts/sections/jsProduct.js



class Product {
  static load(url) {
    return dist_index_es.load(
      url, // template name
      { view: 'quickshop' }, // view name (suffix)
    );
  }

  constructor($section) {
    
    // Add settings from schema to current object
    this._section = $section[0];
    this._data = window.PXUTheme.getSectionData($section);

    this.default_text = JSON.parse(this._data.default_text);
    this.upsell_data = JSON.parse(this._data.upsell_data);

    this.delegateElement = new domDelegate.Delegate($section[0]);
    this.documentDelegate = new domDelegate.Delegate(document.body);

    // Ensure product media libraries are present
    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
      },
    ], window.PXUTheme.productMedia.setupMedia);

    const priceUIEl = $section[0].querySelector('[data-price-ui]');
    const surfacePickUpEl = $section[0].querySelector('[data-surface-pick-up]');

    this.variantSelection = $section[0].querySelector('[data-variant-selection]');

    // this.applyTestStyle();

    // Set conditions for testing
    this.queryParams = new URLSearchParams(document.location.search);
    
    if (document.body.classList.contains("new-styles"))  {
      this.addTestStyle(this._data.second_template_styles);
      this.addFullGalleryButton();
      this.replaceCollapsibleTabs();
      if (!this.queryParams.has("swatches") || this.queryParams.get("swatches") == "round") {
        this.addTestStyle(this._data.round_swathces);
      } else if (this.queryParams.get("swatches") == "square") {
        this.addTestStyle(this._data.square_swathces);
      }
      if (this.queryParams.has("icons") && this.queryParams.get("icons") === "false") {
        this.hideFormIcons();
      }
    }
    // ^ testing options  

    if (this.variantSelection) {
      this.variantSelection.addEventListener('variant-change', event => this._switchVariant(event.detail.product, event.detail.variant, event.detail.state, false));
      if (surfacePickUpEl) {
        this.surfacePickUp = new index_es(surfacePickUpEl);
        this.surfacePickUp.onModalRequest(contents => {
          Promise.all([
            this.variantSelection.getProduct(),
            this.variantSelection.getVariant(),
          ]).then(([product, variant]) => {
            const surfacePickUpModal = $section[0].querySelector('[data-surface-pick-up-modal]');
            const fragment = document.createDocumentFragment();
            const header = document.createElement('div');
            const title = document.createElement('span');
            const subtitle = document.createElement('span');

            header.classList.add('surface-pick-up__modal-header');
            title.classList.add('surface-pick-up__modal-title');
            subtitle.classList.add('surface-pick-up__modal-subtitle');

            title.innerHTML = product.title;
            subtitle.innerHTML = variant.title;

            header.appendChild(title);

            if (variant.title !== 'Default Title') {
              header.appendChild(subtitle);
            }

            fragment.appendChild(header);

            surfacePickUpModal.innerHTML = contents;
            surfacePickUpModal.insertBefore(fragment, surfacePickUpModal.firstChild);
            $.fancybox.open(
              surfacePickUpModal,
              {
                hash: false,
                infobar: false,
                toolbar: false,
                loop: true,
                smallBtn: true,
                buttons: [
                  // "zoom",
                  // "share",
                  // "slideShow",
                  // "fullScreen",
                  // "download",
                  // "thumbs",
                  // "close"
                ],
                touch: false,
                video: {
                  autoStart: false,
                },
                mobile: {
                  preventCaptionOverlap: false,
                  toolbar: true,
                },
                beforeShow: () => {
                  document.body.style.top = `-${window.scrollY}px`;
                  document.body.style.position = 'fixed';
                },
                beforeClose: () => {
                  const scrollY = document.body.style.top;
                  document.body.style.position = '';
                  document.body.style.top = '';
                  window.scrollTo(0, parseInt(scrollY || 0, 10) * -1);
                },
              },
            );
          });
        });
      }
    }
    
    if (priceUIEl) {
      this.priceUI = new PriceUI(priceUIEl);
    }

    const $productGallery = $section.find('.product-gallery__main');
    const $stickyElement = $section.find('.sticky-product-scroll');
    this.productGalleryDelegate = new domDelegate.Delegate($productGallery[0]);

    if ($productGallery) {
      
      this.enableSlideshow($productGallery);
      
      if (this._data.enable_zoom) {
        document.addEventListener('lazyloaded', this.enableZoom);
      }
      
      if (this._data.enable_product_lightbox && this.queryParams.get("template") === "2") {
        // this.enableLightbox($productGallery);
      }

    }

    if ($stickyElement && window.isScreenSizeLarge() && this._data.template === 'image-scroll') {
      this.enableStickyScroll($stickyElement, $productGallery);
    }

    if (window.location.search === '?contact_posted=true') {
      $('.notify_form .contact-form').hide();
      $('.notify_form .contact-form').prev('.message').html(window.PXUTheme.translation.notify_form_success);
    }

    if ($('.masonry--true').length > 0) {
      window.PXUTheme.applyMasonry('.thumbnail');
    }

    // Floating tray
    let floating_add_to_cart_button = this._section.querySelector(".form__floating-button");
    if (floating_add_to_cart_button) {
      this.tray = new Object();
      this.tray.visible = false;
      this.tray.container = floating_add_to_cart_button;
      this.initFloatingTray();
    }
    
    if (document.body.classList.contains("new-styles")) {
      this.initSelectionSteps();
    }

    this._loaded = false;
    if (this.variantSelection) {
      Promise.all([
        this.variantSelection.getProduct(),
        this.variantSelection.getVariant(),
        this.variantSelection.getState(),
        this.getSubsProduct(),
      ]).then(([product, variant, state, subsData]) => {
        this._switchVariant(product,variant,state,true);
        if (subsData) {
          this.initSubscriptionBlock();
        }
      });
    }


    // ---- Custom part ----
    this.delegateElement.on('click', '[data-add-to-cart-trigger-upsell]', this._addUpsellProductToCart.bind(this));
    this.initAccordions();
    document.addEventListener("quantity:updated", this.updatePricesOnButtons.bind(this));

    // upsell product init
    this.upsell_block = this._section.querySelector(".upsell_container");

    // handle Klaviyo Form
    this.backInStockFromContainer = this._section.querySelector(".BiSF_container");
    this.backInStockFrom = this._section.querySelector("#back_in_stock_form");
    this.delegateElement.on('submit', "#back_in_stock_form", this.handleKlaviyoBackInStockFormSubmit.bind(this));

    // Clicking on TrustPilot widget will bring you to review section
    let reviewsSection = document.querySelector(".product_reviews_container");
    if (reviewsSection) {
      this.delegateElement.on('click', "[data-action='scroll-to-reviews']", this.scrollToReviews.bind(this));
    }

    // Open image on varinat tile
    this.delegateElement.on('click', "[data-action='toggle-variant-image']", this.toggleVariantTile.bind(this));

    // Alternative template
    this.delegateElement.on('click', "[data-link-to-section]", this.scrollToSection.bind(this), true);
    window.addEventListener("resize", this.handleGalleryBanner.bind(this));
    let $this = this;
    window.onload = function() {
      $this.handleGalleryBanner();
    }

    let modals = this._section.querySelectorAll("[data-custom-modal]");
    for (let modal of modals) {
      let modalObj = Object.create(window.PXUTheme.customModal);
      modalObj.init(modal);
    }

    if (this._data.textOnImages) {
      this.imageQuotes = Array.from(this._data.textOnImages);
    }
  }

  fetchSubsProduct() {
    this.subscriptionData = {};
    this.subscriptionData.element = this._section.querySelector("[id^=PurchaseTypeBlock]");
    let url = this.subscriptionData.element?.getAttribute("data-product-url");
    if (!url) {
      this._loaded = true;
      this.subscriptionData = null;
      return Promise.resolve(false)
    };
    
    return Promise.all(url.split(",").map(url => fetch(url)))
      .then(responses => {
        let data = Promise.all(responses.map(response => response.json()))
        .then(data => {
          this.subscriptionData.productsFullData = data;
          this._loaded = true;
          return this.subscriptionData;
        });
        return data;
      });

  }

  getSubsProduct() {
    return this._loaded ? Promise.resolve(this.subscriptionData) : this.fetchSubsProduct();
  }

  toggleVariantTile(event,target) {
    event.preventDefault();
    let swatchOptionContainer = target.closest(".swatch__options");
    let variantImages = swatchOptionContainer.querySelectorAll('.tile__images');
    variantImages.forEach(i=>{
      $(i).slideToggle();
    })
    let toggleButtons =  swatchOptionContainer.querySelectorAll("[data-action='toggle-variant-image']");
    toggleButtons.forEach(i=>{
      let icons = i.querySelectorAll(".icon");
      icons.forEach(q=>{
        $(q).toggleClass("icon--active");
      })
    })
  }

  enableStickyScroll($stickyElement, $productGallery) {
    let announcementHeight = 0;
    let headerHeight = 0;

    if (typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky) {
      announcementHeight = $('#announcement-bar').outerHeight();
    }

    if (window.PXUTheme.theme_settings.header_layout !== 'vertical') {
      if (window.PXUTheme.jsHeader.enable_sticky) {
        headerHeight = $('#header').outerHeight();
      }
    }

    const productImages = $productGallery.data('media-count');

    // enable if more than 1 image is present

    if (productImages > 1) {
      $stickyElement.stick_in_parent({
        offset_top: announcementHeight + headerHeight + 20,
      });
    }
  }

  enableLightbox($productGallery) {
    $productGallery.find('.product-gallery__link').fancybox({
      backFocus: false,
      beforeClose: instance => {
        this.main_gallery?.flickity( 'selectCell', instance.currIndex, false, true )
        // const $instanceGallery = instance.$trigger.first().parents('.product-gallery__main');
        // $instanceGallery.hide();
        // setTimeout(() => $instanceGallery.fadeIn(100), 500);
      },
      afterClose: () => {
        setTimeout(() => {
          // $productGallery.find('.is-selected a').focus();
        }, 500);
      },
    });
  }

  enableZoom() {
    const $image = $(event.target);
    const zoomSrc = $image.data('zoom-src');
    if (zoomSrc) {
      $image.wrap('<span class="zoom-container"></span>')
        .css('display', 'block')
        .parent()
        .zoom({
          url: zoomSrc,
          touch: false,
          magnify: 1,
        });
    }
  }

  disableSlideshow($section, selector) {
    let $slider;
    if ($section) {
      $slider = $section.find('.flickity-enabled');
    } else {
      $slider = $(selector);
    }

    $slider.flickity('destroy');
  }

  enableSlideshow(selector, settings) {
    
    if ((document.body.classList.contains("new-styles")) && window.innerWidth > 798) {
      return;
    }
    // Define variables
    const $productGallery = selector;
    const $thumbnailProductGallery = $productGallery.closest('.product-gallery').find('.product-gallery__thumbnails');

    const $slides = $productGallery.find('.product-gallery__image');
    let $thumbnails = $thumbnailProductGallery.find('.product-gallery__thumbnail');

    function autoplayVideo(videoID, $slide) {
      // Compare id to player object and only play that video
      $.each(window.videoPlayers, (_, player) => {
        if (player.id === videoID) {
          player.play();

          // On fullscreen toggle, focus back on the slide itself
          player.on('exitfullscreen', () => $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus());
        }
      });
    }

    function autoplayYoutubeVideo(iframeID, $slide) {
      // compare id to player object and only play that video
      $.each(window.videoPlayers, (_, player) => {
        if (player.playing) {
          player.pause();
        }

        if (player.media.id === iframeID) {
          player.play();

          // On fullscreen toggle, focus back on the slide itself
          player.on('exitfullscreen', () => $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus());
        }
      });
    }

    function checkForVideos() {
      $slides.each((index, slide) => {
        // Variables
        const $slide = $(slide);
        const mediaType = $slide.data('media-type') || $slide.find('[data-media-type]').data('media-type');
        let videoID = $slide.find('video').data('plyr-video-id');
        const $iframeVideo = $slide.find('iframe');
        const iframeID = $iframeVideo.attr('id');
        if ($slide.hasClass('is-selected')) {
          if (mediaType === 'video') {
            videoID = $slide.find('video').data('plyr-video-id');
            if (videoID) {
              autoplayVideo(videoID, $slide);
            }
          } else if (mediaType === 'external_video' && iframeID) {
            autoplayYoutubeVideo(iframeID, $slide);
          }
        }
      });
    }

    // Adds 'product-gallery__image' class if not present
    $productGallery.find('.gallery-cell:not(.product-gallery__image)').addClass('product-gallery__image');

    // Adds 'product-gallery__thumbnail' class if not present
    $thumbnailProductGallery.find('.gallery-cell:not(.product-gallery__thumbnail)').addClass('product-gallery__thumbnail');

    // If custom settings available, use them otherwise take settings from product templates
    const {
      thumbnails_enabled: thumbnailsEnabled,
      enable_thumbnail_slider: thumbnailsSliderEnabled,
      thumbnail_position: thumbnailsPosition,
      gallery_arrows: arrowsEnabled,
      slideshow_speed: slideshowSpeed,
      slideshow_transition: slideshowTransition,
    } = settings || this._data;

    $productGallery.on('ready.flickity', () => {
      $slides.each((index, slide) => {
        // Determine media type
        const mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');
        let videoID;
        const videoLooping = $('[data-video-loop]').data('video-loop');
        const { videoPlayers } = window;

        switch (mediaType) {
          case 'external_video':
            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');
            if (videoPlayers) {
              for (let i = 0; i < videoPlayers.length; i++) {
                if (videoPlayers[i].id === videoID || videoPlayers[i].media.id === videoID) {
                  videoPlayers[i].loop = videoLooping;

                  if (!$(slide).hasClass('is-selected')) {
                    videoPlayers[i].keyboard = {
                      focused: false,
                      global: false,
                    };
                  }
                }
              }
            }

            break;
          case 'video':
            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

            if (videoPlayers) {
              for (let i = 0; i < videoPlayers.length; i++) {
                if (videoPlayers[i].id === videoID || videoPlayers[i].media.id === videoID) {
                  videoPlayers[i].loop = videoLooping;

                  if (!$(slide).hasClass('is-selected')) {
                    videoPlayers[i].keyboard = {
                      focused: true,
                      global: false,
                    };
                  }
                }
              }
            }

            break;
          case 'model':
            if ($(slide).hasClass('is-selected')) { // When active slide
              if (mediaType === 'model' && window.isScreenSizeLarge()) {
                $(slide).on('mouseenter', () => $productGallery.flickity('unbindDrag'));
                $(slide).on('mouseleave', () => $productGallery.flickity('bindDrag'));
              }
            }
            break;
          default:
            break;
        }

        // Detect keyboard 'ENTER' key on slides
        $(slide).keypress(event => {
          if (event.which === 13) {
            // Bring focus to media inside selected slide
            $(slide).find('model-viewer, .product-gallery__link, .plyr').focus();
            // Run video autoplay logic if featured media is a video
            if (mediaType === 'video' || mediaType === 'external_video') {
              checkForVideos();
            }
            // Autoplay model if featured media is a model
            if (mediaType === 'model') {
              // If model container has class is-selected then play the model
              // autoplayModel(); This method does not exist
            }
          }
        });
      });
    });

    let flickityOptions;
    if (!document.body.classList.contains("new-styles")) {
      flickityOptions = {
        wrapAround: true,
        adaptiveHeight: true,
        dragThreshold: 10,
        imagesLoaded: true,
        pageDots: true,
        selectedAttraction: 0.2,
        friction: 0.8,
        lazyLoad: 3,
        prevNextButtons: $productGallery.data('media-count') > 1 || $slides.length > 1,
        autoPlay: slideshowSpeed * 1000,
        fade: slideshowTransition === 'fade',
        watchCSS: this._data.template === 'image-scroll' && !$productGallery.hasClass('js-gallery-modal'), // Disables Flickity for main product gallery on image-scroll template
        arrowShape: window.arrowShape
      }
    } else {
      flickityOptions = {
        wrapAround: true,
        adaptiveHeight: false,
        dragThreshold: 10,
        imagesLoaded: true,
        pageDots: false,
        selectedAttraction: 0.2,
        friction: 0.8,
        lazyLoad: 3,
        prevNextButtons: $productGallery.data('media-count') > 1 || $slides.length > 1,
        autoPlay: slideshowSpeed * 1000,
        fade: slideshowTransition === 'fade',
        watchCSS: false,
        arrowShape: window.arrowShapeAlternative,
        cellAlign: 'left'
      }
    }

    this.main_gallery = $productGallery.flickity(flickityOptions);
    $productGallery.on('change.flickity', (event, index) => {
      $slides.each((index, slide) => {
        // Determine media type of current slide
        const mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');

        if ($(slide).hasClass('is-selected')) { // When active slide
          switch (mediaType) {
            case 'model':
              /* On slide change, if active slide contains 3d model
              * If on desktop, on hover, unbind flickity, after hover bind flickity
              * On model play event, unbind flickity to ensure model can be interacted with
              * On model pause event, bind flickity so that slide can be swiped
              * Pause all model slides when hidden
              */

              if (window.isScreenSizeLarge()) {
                // On mouseenter event, unbind flickity
                $(slide).on('mouseenter', () => $productGallery.flickity('unbindDrag'));

                // On mouseleave event, bind flickity
                $(slide).on('mouseleave', () => $productGallery.flickity('bindDrag'));
              }

              // Listen for model pause/play events
              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', () => $productGallery.flickity('unbindDrag'));
              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', () => $productGallery.flickity('bindDrag'));

              break;
            default:
              $productGallery.flickity('bindDrag');
          }
        } else {
          // When inactive slide
          switch (mediaType) {
            case 'external_video':
              // Youtube video pausing
              $.each(window.videoPlayers, (_, player) => player.pause());

              break;
            case 'video':
              // HTML5 video pausing
              $.each(window.videoPlayers, (_, player) => player.pause());

              break;
            case 'model':
              $.each(window.PXUTheme.productMedia.models, (_, model) => model.pause());
              break;
            default:
              break;
          }
        }
      });
      // Restore 3d model icons
      window.PXUTheme.productMedia.showModelIcon($productGallery);
    });

    // Checks for videos and plays them if they are the featured media
    // Autoplay logic only happens on desktop, autoplay set to off for mobile
    const $sliderArrows = $productGallery.find('.flickity-prev-next-button');

    if (($sliderArrows || $thumbnails) && window.isScreenSizeLarge()) {
      $sliderArrows.on('click', () => {
        $productGallery.on('settle.flickity', () => {
          // Find out media type of featured media slide
          const $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
          const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
          const pId = ($productGallery).data('product-id');

          // Run video autoplay logic if featured media is a video
          if (mediaType === 'video' || mediaType === 'external_video') {
            checkForVideos();
          }

          // Autoplay model if featured media is a model
          if (mediaType === 'model') {
            // Sort models to get those in selected slide
            const sortedModels = [];

            $.each(window.PXUTheme.productMedia.models, (index, model) => {
              if ($(model.container).closest('.product-gallery__image').data('product-id') === pId) {
                sortedModels.push(model);
              }
            });

            // If model container has class is-selected then play the model
            $.each(sortedModels, (index, model) => {
              const $slide = $(model.container).parents('.product-gallery__image');
              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }

          $productGallery.off('settle.flickity');
        });

        return false;
      });

      // $thumbnails.on('click', event => {
      //   const index = $(event.currentTarget).index();
      //   $productGallery.flickity('select', index);

      //   $productGallery.on('settle.flickity', () => {
      //     // Find out media type of featured media slide
      //     const $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
      //     const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
      //     const pId = ($productGallery).data('product-id');

      //     // Run video autoplay logic if featured media is a video
      //     if (mediaType === 'video' || mediaType === 'external_video') {
      //       checkForVideos();
      //     }

      //     // Autoplay model if featured media is a model
      //     if (mediaType === 'model') {
      //       // Sort models to get those in selected slide
      //       const sortedModels = [];
      //       $.each(window.PXUTheme.productMedia.models, (_, model) => {
      //         if ($(model.container).closest('.product-gallery__image').data('product-id') === pId) {
      //           sortedModels.push(model);
      //         }
      //       });

      //       // If model container has class is-selected then play the model
      //       $.each(sortedModels, (_, model) => {
      //         const $slide = $(model.container).parents('.product-gallery__image');
      //         if ($slide.hasClass('is-selected')) {
      //           model.play();
      //         }
      //       });
      //     }

      //     $productGallery.off('settle.flickity');
      //   });

      //   return false;
      // });

      // $thumbnails.keypress(event => {
      //   const index = $(event.currentTarget).index();
      //   if (event.which === 13) {
      //     $productGallery.flickity('select', index);

      //     const $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
      //     const pId = ($productGallery).data('product-id');

      //     $productGallery.on('settle.flickity', () => {
      //       $selectedSlide.find('model-viewer, .plyr, a').focus();
      //       $selectedSlide.find('[data-youtube-video]').attr('tabindex', '0');
      //       $productGallery.off('settle.flickity');
      //     });

      //     // Find out media type of featured media slide
      //     const mediaType = $selectedSlide.data('media-type');

      //     // Run video autoplay logic if featured media is a video
      //     if (mediaType === 'video' || mediaType === 'external_video') {
      //       checkForVideos();
      //     }

      //     // Autoplay model if featured media is a model
      //     if (mediaType === 'model') {
      //       // Sort models to get those in selected slide
      //       const sortedModels = [];
      //       $.each(window.PXUTheme.productMedia.models, (_, model) => {
      //         if ($(model.container).closest('.product-gallery__image').data('product-id') === pId) {
      //           sortedModels.push(model);
      //         }
      //       });

      //       // If model container has class is-selected then play the model
      //       $.each(sortedModels, (_, model) => {
      //         const $slide = $(model.container).parents('.product-gallery__image');
      //         if ($slide.hasClass('is-selected')) {
      //           model.play();
      //         }
      //       });
      //     }
      //   }
      // });

      this.delegateElement = new domDelegate.Delegate(this._section);
      this.delegateElement.on("click", ".product-gallery__thumbnail", function(event){
        const index = $(event.target).closest(".product-gallery__thumbnail").index();

        $productGallery.flickity('select', index);

        $productGallery.on('settle.flickity', () => {
          // Find out media type of featured media slide
          const $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
          const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
          const pId = ($productGallery).data('product-id');

          // Run video autoplay logic if featured media is a video
          if (mediaType === 'video' || mediaType === 'external_video') {
            checkForVideos();
          }

          // Autoplay model if featured media is a model
          if (mediaType === 'model') {
            // Sort models to get those in selected slide
            const sortedModels = [];
            $.each(window.PXUTheme.productMedia.models, (_, model) => {
              if ($(model.container).closest('.product-gallery__image').data('product-id') === pId) {
                sortedModels.push(model);
              }
            });

            // If model container has class is-selected then play the model
            $.each(sortedModels, (_, model) => {
              const $slide = $(model.container).parents('.product-gallery__image');
              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }

          $productGallery.off('settle.flickity');
        });

        return false;
      })

    } else if (thumbnailsEnabled) {
      // If thumbnail slider is disabled, ensure thumbnails can still navigate product images
      $thumbnailProductGallery.find('.product-gallery__thumbnail').on('click', event => {
        const $currentTarget = $(event.currentTarget);
        const index = $currentTarget.index();
        $productGallery.flickity('selectCell', index);
      });
    }

    // Resize flickity when the slider is settled
    $productGallery.on('settle.flickity', () => $productGallery.flickity('resize'));

    $(window).on('load', () => $productGallery.flickity('resize'));

    let resizeTimer;

    $(window).on('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => $productGallery.flickity('resize'), 250);
    });
    
    if (thumbnailsEnabled === true && thumbnailsSliderEnabled === true && $slides.length > 1) {
      // If desktop determine which slider we build
      if (window.isScreenSizeLarge()) {
        if (thumbnailsPosition === 'right-thumbnails' || thumbnailsPosition === 'left-thumbnails') {
          $thumbnailProductGallery.addClass('vertical-slider-enabled');

          let navCellHeight = $thumbnails.height();
          let navHeight = $thumbnailProductGallery.height();

          // Resize thumbnail gallery

          $(window).on('load', () => {
            const $productGalleryHeight = $productGallery.height();
            $thumbnailProductGallery.css('max-height', $productGalleryHeight);
          });

          $(window).on('resize', () => {
            $productGallery.flickity('resize');
            const $productGalleryHeight = $productGallery.height();
            $thumbnailProductGallery.css('max-height', $productGalleryHeight);
          });

          $productGallery.on('change.flickity', () => {
            // $productGallery.flickity('resize');
            const $productGalleryHeight = $productGallery.height();
            $thumbnailProductGallery.css('max-height', $productGalleryHeight);
          });

          $productGallery.on('change.flickity', () => {
            // set selected nav cell
            $thumbnails = $thumbnailProductGallery.find('.product-gallery__thumbnail');
            navCellHeight = $thumbnails.height();
            navHeight = $thumbnailProductGallery.height();
            let flkty = this.main_gallery.data('flickity');

            if (flkty) {
              $thumbnailProductGallery.find('.is-nav-selected').removeClass('is-nav-selected');
              const $selected = $thumbnails.eq(flkty.selectedIndex).addClass('is-nav-selected');

              // scroll nav
              const scrollY = (
                $selected.position().top
                + $thumbnailProductGallery.scrollTop()
                - (navHeight - navCellHeight)
                / 2
              );

              $thumbnailProductGallery.animate({
                scrollTop: scrollY,
              }, 400);
            }
          });
        } else {
          $thumbnailProductGallery.flickity({
            cellAlign: 'center',
            contain: true,
            groupCells: '80%',
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons: $thumbnails.length > 5 ? arrowsEnabled : false,
            asNavFor: this._data.template === 'image-scroll' && window.isScreenSizeLarge() ? '' : $productGallery[0],
            arrowShape: window.arrowShape,
          });

          // Resize flickity when the slider is settled
          $thumbnailProductGallery.on('settle.flickity', () => $thumbnailProductGallery.flickity('resize'));
          $(window).on('load', () => $thumbnailProductGallery.flickity('resize'));
        }
      } else {
        // Otherwise create standard thumbnail slider
        // $thumbnailProductGallery.flickity({
        //   cellAlign: 'center',
        //   contain: true,
        //   groupCells: '80%',
        //   imagesLoaded: true,
        //   pageDots: false,
        //   prevNextButtons: $thumbnails.length > 5,
        //   asNavFor: this._data.template === 'image-scroll' && window.isScreenSizeLarge() ? '' : $productGallery[0],
        //   arrowShape: window.arrowShape,
        // });
      }
    }
    
    // product-gallery__main
    let data = this.main_gallery.data('flickity');
    this.productGalleryDelegate.on('touchstart', (event,target) => {
      if (event.touches.length >= 2) {
        data.options.draggable = false;
        data.updateDraggable();
        $productGallery[0].style.pointerEvents = "none";
        document.body.focus();
        window.focus();
      }
    });
    this.productGalleryDelegate.on('touchend', (event,target) => {
      data.options.draggable = true;
      data.updateDraggable();
      $productGallery[0].style.pointerEvents = "auto";
    });
  }

  findSelectedVariantImage() {
    function getIndex($selector, variantID) {
      const $parentForm = $selector.parents('.product_form');
      const $option = $parentForm.find(`select option[value=${variantID}]`);
      const imageID = $option.attr('data-image-id');
      if (!imageID) {
        // If there is no image, no scrolling occurs
        return false;
      }

      const index = $(`[data-image-id=${imageID}]`).data('index');
      if (this._data.template === 'image-scroll') {
        this.scrollSelectedImage(index);
        return true;
      }

      return false;
    }

    $('[data-variant-selector]').on('selectedVariantChanged', event => {
      const $currentTarget = $(event.currentTarget);
      if (!$currentTarget.attr('disabled')) {
        getIndex($currentTarget, $currentTarget.val());
      }
    });
  }

  scrollSelectedImage(variant) {
    let headerHeight = 0;
    let announceHeight = 0;

    // Get header height is sticky enabled
    if (window.PXUTheme.jsHeader.enable_sticky === true && window.PXUTheme.theme_settings.header_layout !== 'vertical') {
      headerHeight = window.PXUTheme.jsHeader.getHeaderHeight();
    }

    // Get announcement height is sticky enabled
    if (
      typeof window.PXUTheme.jsAnnouncementBar !== 'undefined'
      && window.PXUTheme.jsAnnouncementBar.enable_sticky === true
      && window.PXUTheme.theme_settings.header_layout !== 'vertical'
    ) {
      announceHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
    }

    // Add values
    const totalHeight = headerHeight + announceHeight;

    window.PXUTheme.scrollToTop($(`[data-index="${variant}"]`), totalHeight);
  }

  unload($section) {
    $('.selector-wrapper select', $section).unwrap();
    this.disableSlideshow($section);
    $('[data-variant-selector]').off();
    document.removeEventListener('lazyloaded', this.enableZoom);
  }

  _switchVariant(product, variant, state, initial) {
    this.selectedVariant = variant;

    if(!this._data.no_variants) {
      this.handleVariantImageSelection(variant, initial, product);
    } else {
      this.main_gallery.flickity('select', 0, false, true);
      this.main_gallery[0].classList.add("loaded");
      // Fix initial thumbnails oversize and dots
      var dots = this.main_gallery[0].querySelector(".flickity-page-dots");
      var thumbnail_images_container = this._section.querySelector(".product-gallery__thumbnails");
      dots.classList.add("loaded");
      if (thumbnail_images_container) {
        thumbnail_images_container.classList.add("loaded");
      }
    }

    window.selectCallback(
      this._section.querySelector(`.product-${product.id}`),
      product,
      variant,
      state,
      initial,
      this.queryParams
    );

    let moneyFormat = $('body').data('money-format');

    if (this.priceUI) {
      const formatter = price => (
        price === 0
          ? window.PXUTheme.translation.free_price_text
          : Shopify.formatMoney(price, moneyFormat)
      );
      this.priceUI.load(
        product,
        {
          variant,
          formatter,
          handler: (priceUIFragment, p, { variant: v }) => {
            if (state === 'unavailable') {
              return document.createDocumentFragment();
            }

            if (v && v.available) {
              const shopPayInstallmentsTemplate = this._section.querySelector('[data-shop-pay-installments-template] shopify-payment-terms');
              let shopPayInstallEl = null;

              if (shopPayInstallmentsTemplate) {
                shopPayInstallEl = shopPayInstallmentsTemplate.cloneNode(true);
                shopPayInstallEl.setAttribute('variant-id', variant.id);
              }

              if (this._data.display_savings && v.compare_at_price > v.price) {
                const span = document.createElement('span');
                const wrapper = document.createElement('p');

                wrapper.classList.add('sale_price-wrapper');
                span.classList.add('slabel', 'slabel-green');
                // span.innerHTML = `${window.PXUTheme.translation.product_savings} ${parseInt(((v.compare_at_price - v.price) * 100) / v.compare_at_price, 10)}% (<span class="money">${formatter(v.compare_at_price - v.price)}</span>)`;
                span.innerHTML = `${parseInt(((v.compare_at_price - v.price) * 100) / v.compare_at_price, 10)}%${window.PXUTheme.translation.product_savings}`;
                wrapper.appendChild(span)
                priceUIFragment.appendChild(wrapper);
              }

              this.updatePricesOnButtons();
              if (document.body.classList.contains("AlternativeTemplate")) {
                btnPrice.textContent = Shopify.formatMoney(v.price, document.body.getAttribute("data-money-format-without-decimals"));
              }
              if (shopPayInstallEl) {
                priceUIFragment.appendChild(shopPayInstallEl);
              }

              let salePercentContainer = this.priceUI._el.parentNode.querySelector(".discount_text [data-savings]");
              if (salePercentContainer) {
                if (v.compare_at_price > v.price) {
                  let percent = parseInt(((v.compare_at_price - v.price) * 100) / v.compare_at_price, 10);
                  salePercentContainer.textContent = `${percent}%`;
                  salePercentContainer.parentNode.classList.remove("loading");
                } else {
                  salePercentContainer.parentNode.classList.add("loading");
                }
              }

              // Update prices in total
              let totalPriceEl =  this._section.querySelector(".purchase-details--price_container--total_wrapper--amount");
              totalPriceEl.setAttribute("data-variant-id", v.id);
              let priceElContainer = document.querySelector(".purchase-details--price_container--total_wrapper");
              let added = 0;
              let region = document.querySelector("body").dataset.selectedRegion;
              let fetchedCountry = document.querySelector("body").dataset.fetchedCountry;

              if(document.getElementById('PurchaseTypeBlock') && document.querySelector('body.new-styles')) {
                if(!document.querySelector('.PurchaseTypeBlock-button.Active').classList.contains('default')){
                  if(fetchedCountry == 'United Kingdom' || fetchedCountry == 'United States'){
                    added = 900;
                    if(region == 'US') {
                      added = 1198;
                    }
                  }
                }
              }

              priceElContainer.dataset.price = v.price;              
            }

            // Convert all elements if currency converter is enabled
            if (window.PXUTheme.currencyConverter) {
              const moneyEls = priceUIFragment.querySelectorAll('.money');

              for (let i = 0; i < moneyEls.length; i++) {
                window.PXUTheme.currencyConverter.update(moneyEls[i]);
              }
            }

            return priceUIFragment;
          },
        },
      );
    }

    // this part broke selected currency in sidecart 
    // if (this.surfacePickUp) {
    //   this.surfacePickUp.load(variant ? variant.id : null);
    // }
    
    // Handle upsell block 
    if (this.upsell_block) {
      this._handleUpsellBlock(variant);
    }

    if (this.backInStockFrom) {
      this.backInStockFrom.setAttribute("data-variant-id", variant.id)
      if (variant && !variant.available) {
        $(this.backInStockFromContainer).hide();
        // $(this.backInStockFromContainer).slideDown();
      } else {
        $(this.backInStockFromContainer).hide();
      }
    }

    // Switch blocks in "Whats in the box" tab
    let tab_items = document.querySelectorAll(".variant--whats_in_the_box");
    tab_items.forEach(i=>{
      i.getAttribute("data-variant") == variant.id ? i.classList.add("active") : i.classList.remove("active");
    });

    if (this.tray) {
      this.updateTrayVariantLabels(product, variant, state, initial);
    }

    // Change image in size tiles
    if (this._section.querySelector(".tile__images")) {
      this.selectSwatchVariantImage(variant);
    }
    
    // ToothBrush updates
    let tiles = document.querySelector("[data-bundle-option]");
    if (tiles) {
      this.updateTilesProductPrice(product, variant, state, initial);
    }

    if (initial !== true && this.subscriptionData !== null) {
      this.handleSubscripionCartData(this.subscriptionData.purchaseID);
    }

    document.getElementsByTagName("klarna-placement")[0]?.setAttribute("data-purchase-amount", variant.price);
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });

  }

  selectSwatchVariantImage(variant) {
    
    let optionsSet = ['option1', 'option2', 'option3'];
    let swatchContainer = this._section.querySelector("[data-bundle-option]");

    let untouchedOption = "option" + swatchContainer.getAttribute("data-option-index");
    let index = optionsSet.indexOf(untouchedOption);

    optionsSet.splice(index, 1);

    let tileImages = swatchContainer.querySelectorAll(".tile__image");
    tileImages.forEach(image=>{
      if (variant[optionsSet[0]] !== null) {
        if (image.dataset[optionsSet[0]] === variant[optionsSet[0]]) {
          if (variant[optionsSet[1]] !== null) {
            if (image.dataset[optionsSet[1]] === variant[optionsSet[1]]) {
              image.classList.add("selected")
            } else {
              image.classList.remove("selected")
            }
          } else {
            image.classList.add("selected")
          }
        } else {
          image.classList.remove("selected")
        }
      }
    });
  }

  _addUpsellProductToCart(event, element) {
    if (element.hasAttribute("disabled")) return;
    var elementID = element.getAttribute("data-add-to-cart-trigger-upsell");
    let _this = this;

    $.ajax({
      url: window.PXUTheme.routes.cart_add_url,
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        'items': [
          {
            'id': _this.active_upsell.upsell_variant_id,
            'quantity': _this.active_upsell.upsell_count
          }
        ]
      },
      beforeSend: function () {
      },
      success: function (product) {

        window.PXUTheme.jsCart.updateCart();
        window.PXUTheme.jsCart.toggleCart();

      },
      error: function (XMLHttpRequest) {
        let response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  }

  _handleUpsellBlock(variant) {
    this.active_upsell = this.upsell_data[variant.id];
    if (!this.upsell_block) {
      $(this.upsell_block).slideUp(300);
      return;
    }
    // Select image
    var upsellImages = this.upsell_block.querySelectorAll("[data-upsell-variant-image]");
    upsellImages.forEach(image=> {
      image.getAttribute("data-upsell-variant-image") == this.active_upsell.upsell_variant_id ? image.setAttribute("aria-hidden", false) : image.setAttribute("aria-hidden", true);
    });

    // selectors
    let $block_title = this.upsell_block.querySelector(".upsell_product-title");
    let $block_subtitle = this.upsell_block.querySelector(".upsell_product-subtitle");
    let $block_button = this.upsell_block.querySelector("[data-add-to-cart-trigger-upsell]");
    let $block_preorder_info = this.upsell_block.querySelector(".preorder_info");

    // Title
    let title_content = this.active_upsell.block_title ? this.active_upsell.block_title : this.default_text.default_title;
    if (title_content.length > 0) {
      $block_title.textContent = title_content;
      $($block_title).slideDown(200)
    } else {
      $($block_title).hide();
    }

    // Subtitle
    let subtitle_content = this.active_upsell.block_subtitle ? this.active_upsell.block_subtitle : this.default_text.default_subtitle;
    if (subtitle_content.length > 0) {
      $block_subtitle.textContent = subtitle_content;
      $($block_subtitle).slideDown(200)
    } else {
      $($block_subtitle).hide();
    }

    // preorder info
    let preorder_info_content = this.active_upsell.block_preorder_info ? this.active_upsell.block_preorder_info : this.default_text.default_preorder_info
    $block_preorder_info.textContent = preorder_info_content;

    console.log(1);

    // Button
    let regex = /\(price\)/i;
    if (this.active_upsell.upsell_variant_available && this.active_upsell.upsell_variant_inventory > 0) {
      $block_button.textContent = this.default_text.default_button_copy.replace(regex, this.active_upsell.upsell_variant_price);
      $block_button.disabled = false;
      $($block_preorder_info).hide();
    } else if (this.active_upsell.upsell_variant_available && this.active_upsell.upsell_variant_inventory <= 0) {
      $block_button.textContent = this.default_text.default_preorder_button_copy.replace(regex, this.active_upsell.upsell_variant_price);
      $block_button.disabled = false;
      if ($block_preorder_info.textContent.length > 0) $($block_preorder_info).slideDown(200);
    } else {
      $block_button.textContent = this.default_text.default_sold_out_button_copy.replace(regex, this.active_upsell.upsell_variant_price);
      $block_button.disabled = true;
      $($block_preorder_info).hide();
    }

    $(this.upsell_block).slideDown(300);
  }

  initAccordions() {
    const $accordionHeading = $('[data-collapsible-tabs] dt > button');

    $('[data-collapsible-tabs] [data-initially-expanded="false"] dd').attr('aria-hidden',true);

    $('[data-collapsible-tabs] [data-initially-expanded="false"] dt > button').attr('aria-expanded',false);


    $('[data-collapsible-tabs][data-layout="Mobile"] [data-initially-expanded="true"]').eq(1).find('dd').attr('aria-hidden',true);

    $('[data-collapsible-tabs][data-layout="Mobile"] [data-initially-expanded="true"]').eq(1).find('dt > button').attr('aria-expanded',false);

    $accordionHeading.on('click activate',function(){
      const accordionTitle = $(this);
      const accordionIcons = $(this).find('.icon');

      let state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded',state);
      $(this).parent().next().slideToggle(function(){

        if(accordionIcons.hasClass('icon--active')) {
          accordionIcons.toggleClass('icon--active');
        }

      });
      $(this).parent().next().attr('aria-hidden',!state);
      return false;
    });

    $accordionHeading.on('keydown',function(event){
      let keyCode = event.keyCode || e.which;
      if (keyCode === 13){
        $(this).trigger('activate');
      }
    });
  }

  handleVariantImageSelection(variant, initial, product) {
    if ((document.body.classList.contains("new-styles")) && window.innerWidth > 798) {
      this.handleVariantImageSelection2(variant, initial, product);
      return;
    }

    const alt = 'xs:' + variant.option1.replace(' ', '-').toLowerCase();
    
    let productVariantsMediaIDs = [];
    
    // if(variant.featured_media) {
    //   console.log(variant.featured_media)
    //   for (let tempVariant of product.variants) {
    //     if (tempVariant.id !== variant.id) {
    //       productVariantsMediaIDs.push(tempVariant.featured_media.id);
    //     }
    //   }
    // }

    // Create temporary element to work with cells
    let temp_images_element = document.createElement("div");
    temp_images_element.innerHTML = this._data.all_images_html;
    
    // Create array with cells to be added to carousel;
    // Include all cells with alt tag of fetured image tag, excluding image of linked variant;
    let cellsToBeAdded = [];
    let cellPushedIndex = 0;
    let tempCells = Array.from(temp_images_element.querySelectorAll(".product-gallery__image"));
    for (let cell of tempCells) {
      if (cell.getAttribute("data-variant-name") === alt && productVariantsMediaIDs.indexOf(Number(cell.getAttribute("data-media-id"))) < 0) {
        if (this.queryParams.get("quotes") === "true") {
          cellsToBeAdded.push(this.addQuoteToImage(cell, cellPushedIndex));
          cellPushedIndex++;
        } else {
          cellsToBeAdded.push(cell);
        }
      }
    }

    let cellsToBeRemoved = this.main_gallery[0].querySelectorAll(".product-gallery__image");

    this.main_gallery.flickity('prepend', cellsToBeAdded);
    this.main_gallery.flickity('remove', cellsToBeRemoved);

    // THUMBNAILS
    let temp_thumbnails_element = document.createElement("div");
    temp_images_element.innerHTML = this._data.all_thumbnail_images_html;
    let thumbnailsContainer = document.querySelector(".product-gallery__thumbnails");
    let thumbnailsByColor = temp_images_element.querySelectorAll(`.product-gallery__thumbnail[data-title='${alt}']`);
    let thumbnailsArray = [...thumbnailsByColor];
    let finalThumbnailsArray = thumbnailsArray.filter((thumbnail)=>{
      let mediaID = Number(thumbnail.getAttribute("data-media-id"));
      if (productVariantsMediaIDs.indexOf(mediaID) < 0) {
        return thumbnail;
      }
    });
    thumbnailsContainer.innerHTML = "";
    for (let thumbnail of finalThumbnailsArray) {
      thumbnailsContainer.append(thumbnail);
    }
    
    if (initial) {
      this.main_gallery.flickity('select', 0, false, true);
      this.main_gallery[0].classList.add("loaded");
      // Fix initial thumbnails oversize and dots
      var dots = this.main_gallery[0].querySelector(".flickity-page-dots");
      dots?.classList.add("loaded");
    } else {
      this.main_gallery.flickity('select', 0, false, true);
      // let variantMediaID = variant.featured_media.id;
      // let varianImageWrapper = document.querySelector(`.product-gallery__image[data-media-id="${variantMediaID}"]`);
      // let index = $(varianImageWrapper).index();
      // this.main_gallery.flickity('select', index, false, true);
    }
    let gallery = $(this._section).find('.product-gallery__main');

  } 

  handleKlaviyoBackInStockFormSubmit(event,target) {
    event.preventDefault();
    let klaviyoAPIKey = "UQnRNw";
    let variantID = target.getAttribute("data-variant-id");
    let email = target.querySelector('.BiSF_email').value;
    if (!variantID || !email) {
      return;
    }
    let loadingGif = target.querySelector(".BiSF_loading-overlay");
    let parentContainer = target.closest(".BiSF_container");
    $.ajax({
      type: "POST",
      url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
      data: {
        a: klaviyoAPIKey,
        email: email,
        variant: variantID,
        platform: "shopify"
      },
      dataType: "json",
      beforeSend: function() {
        parentContainer.classList.add("loading");
      },
      success: function(response){
        if (response.success == true) {
          parentContainer.classList.add("submited_sccessfully");
          parentContainer.classList.remove("loading");
        } else {
          parentContainer.classList.add("submit_failed");
        }
      },
      fail: function(error) {
        parentContainer.classList.add("submit_failed");
      },
      error: function(error) {
        parentContainer.classList.add("submit_failed");
      }
    });
  }

  // Floating tray on produt page
  initFloatingTray() {
    this.tray.targetButton = this._section.querySelector("form [data-add-to-cart-trigger]");
    document.addEventListener("quantity:updated", this.updateTrayQuantityLabel.bind(this));
    window.addEventListener("scroll", this.trayAppearance.bind(this));
    this.tray.button = this.tray.container.querySelector("button[type='submit']");
    this.delegateElement.on("click", ".form__floating-button [data-add-to-cart-trigger]", this._checkVariantSelectionSteps.bind(this));
    
    if(!document.querySelector('[data-bundle-option]')){
      this.tray.button.classList.add('ajax-submit');
    }

    this.trayAppearance();
  }
   
  trayAppearance() {
    let headerElement = document.querySelector(".jsHeader > div");
    let headerCorrection = headerElement.offsetHeight;
    
    if (this._data.template == "page_LP-v4") {
      let targetElement = document.querySelector(".dynamic-sections > div:first-child");
      let targetElementBottom = targetElement.getBoundingClientRect().bottom;
      if (targetElementBottom - headerCorrection < 0 && !this.tray.visible) {
        this.tray.container.setAttribute("aria-hidden", false);
        this.tray.visible = true;
      }
      if (targetElementBottom - headerCorrection >= 0 && this.tray.visible) {
        this.tray.container.setAttribute("aria-hidden", true);
        this.tray.visible = false;
      }
      return;
    }

    let _this = this;
    let targetBottom = this.tray.targetButton.getBoundingClientRect().bottom;
    let targetTop = this.tray.targetButton.getBoundingClientRect().top;
    if (targetBottom - headerCorrection < 0 && !this.tray.visible) {
      this.tray.container.setAttribute("aria-hidden", false);
      this.tray.visible = true;
      document.dispatchEvent(new CustomEvent('tray:action', { 
        detail: {
          appear: true,
          element: _this.tray.container
        } 
      }));
      let cookieBanner = document.querySelector("#shopify-pc__banner");
      if (cookieBanner) {
        $(cookieBanner).animate({
          bottom: this.tray.container.clientHeight
        }, 500)
      }
    }
    if (targetTop - headerCorrection >= 0 && this.tray.visible) {
      this.tray.container.setAttribute("aria-hidden", true);
      this.tray.visible = false;
      document.dispatchEvent(new CustomEvent('tray:action', { 
        detail: {
          appear: false,
          element: _this.tray.container
        } 
      }));
      let cookieBanner = document.querySelector("#shopify-pc__banner");
      if (cookieBanner) {
        $(cookieBanner).animate({
          bottom: 0
        }, 500)
      }
    }
  }
  
  updateTrayVariantLabels() {
    if (!this.tray) return;
    let variantLabel = this.tray.container.querySelector(".form__floating-button_variant-label");
    let selectionStep = this._section.querySelector("[data-selection-step='false'][data-selection]");
    if (!selectionStep) {
      variantLabel.textContent = this.selectedVariant.public_title;
      return;
    }
    let selectionStepTitle = selectionStep.querySelector(".description_heading span:last-child") ? selectionStep.querySelector(".description_heading span:last-child") : selectionStep.querySelector(".description_heading");
    let label = selectionStepTitle.textContent.replace(/([0-9]\.)|\:/, '');
    if (!label.includes("Choose") && !label.includes("Pick") ) {
      label = "Choose " + label.toLowerCase();
    }
    variantLabel.textContent = label;
  }

  updateTrayButton() {
    if (!this.tray) return;

    let trayButton = this.tray.container.querySelector("button[type='submit'] .button--add-to-cart-label-text");
    if (!trayButton) return;

    let selectionStep = this._section.querySelector("[data-selection-step='false'][data-selection]");

    if (!selectionStep) {
      trayButton.textContent = 'Add to cart';
      return;
    }

    let selectionStepTitle = selectionStep.querySelector(".description_heading span:last-child") ? selectionStep.querySelector(".description_heading span:last-child") : selectionStep.querySelector(".description_heading");
    let label = selectionStepTitle.textContent.replace(/([0-9]\.)|\:/, '');
    if (!label.includes("Choose") && !label.includes("Pick") ) {
      label = "Choose " + label.toLowerCase();
    }

    trayButton.textContent = label;
  }
  
  updateTrayQuantityLabel(event, target) {
    let quantityButton = event.detail;
    let productForm = quantityButton.closest(".shopify-product-form");
    if (!productForm) return;
    let quantityInput = productForm.querySelector("input[name='quantity']");
    let inputVal = quantityInput.value;
    let quantityLabel = this.tray.container.querySelector(".form__floating-button_quantity-label-amount");
    quantityLabel.textContent = inputVal;
  }

  _checkVariantSelectionSteps(event, target) {
    console.log('Checking selection steps');
    console.log(event.target.classList);
    if (event.target.closest('button').classList.contains("ajax-submit")) return;
    event.preventDefault();

    let targetEl = document.querySelector("[data-selection]");
    targetEl.classList.remove("Attention");

    let header = document.querySelector("#shopify-section-header-classic");
    let subheader = document.querySelector("#shopify-section-subheader-bar");
    let targetPX = window.scrollY + targetEl.getBoundingClientRect().top - header.clientHeight - (subheader ? subheader.clientHeight : 0) - 20;
    $("html, body").animate({ scrollTop: targetPX + 'px' }, 400, () => window.requestAnimationFrame(function(){targetEl.classList.add("Attention")}));

  }

  // TrustPilot logo click
  scrollToReviews(event, target) {
    event.preventDefault();
    let targetSection = document.querySelector(".product_reviews_container");
    let headerElement = document.querySelector(".jsHeader > div");
    let headerCorrection = headerElement.offsetHeight;
    let targetSectionTop = targetSection.getBoundingClientRect().top;
    let scrollPx = targetSectionTop - headerCorrection;
    $("html, body").animate({ scrollTop: scrollPx + 'px' }, 1000);
  }

  // For testing purposes
  applyTestStyle() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    let enableNewTemplate = params.altView;
    if (enableNewTemplate == "icon_PDP") {
      document.body.classList.add("AlternativeTemplate");
    }
  }

  handleGalleryBanner(event, target) {
    let banner = document.querySelector(".product-gallery__banner");
    if (!banner) return;
    let root = document.querySelector(':root');
    let scaleValue;
    if (window.innerWidth >= 799) {
      scaleValue = 1 + (window.innerWidth - 1250) / 950;
      scaleValue = scaleValue > 1.3 ? 1.3 : scaleValue < 0.5 ? 0.5 : scaleValue;
    } else {      
      scaleValue = 1 + (window.innerWidth - 799) / 900;
    }
    root.style.setProperty('--scale', scaleValue);
    banner.classList.add("appear")
  }

  updateTilesProductPrice(product, variant, state, initial) {
    // Check bundle options
    if (variant === false) return
    let tiles = document.querySelectorAll("[data-bundle-option] .swatch__option");
    let optionIndex = document.querySelector("[data-bundle-option]").getAttribute("data-option-index") - 1;
    let optionsArray = variant.options;
    let moneyFormat = document.body.getAttribute("data-money-format");

    if (tiles.length > 0) {
      tiles.forEach(tile => {
        let tileValue = tile.querySelector("[data-variant-option-value]").value;
        let newOptionsArray = [...optionsArray];
        newOptionsArray.splice(optionIndex, 1, tileValue);
        
        let tileVariant = product.variants.filter(variant => {
          return variant.options.length === newOptionsArray.length && variant.options.every(function(value, index) { 
            return value === newOptionsArray[index]
          })
        })[0];
        if (tileVariant === undefined) return;

        let price = tile.querySelector(".alternate-price");
        let compare_at_price = tile.querySelector(".alternate-compare_at_price");
        let savings = tile.querySelector(".alternate-savings");
        price.setAttribute("data-variant-id", tileVariant.id);
        
        // if(tileVariant.id == 53480776171899){
        //   price.textContent = 'Unavailable';
        //   price.closest(".swatch__option.brush-only").classList.add("disabled");
        // } else {
          price.textContent = Shopify.formatMoney(tileVariant.price, moneyFormat);          
        // }
        
        let savingsBadge = tile.querySelector(".tile__badge.savings");
        if (savingsBadge) savingsBadge.remove();

        if (tileVariant.compare_at_price > tileVariant.price) {
          compare_at_price.textContent = Shopify.formatMoney(tileVariant.compare_at_price, moneyFormat);
          compare_at_price.style.display = "flex";          
          savings.innerHTML = `${parseInt(((tileVariant.compare_at_price - tileVariant.price) * 100) / tileVariant.compare_at_price, 10)}%${window.PXUTheme.translation.product_savings}`;

          if (!document.body.classList.contains("new-styles")) {
            savings.parentNode.style.display = "flex";
          }
          if (document.body.classList.contains("new-styles")) {
            let badge = document.createElement("div");
            badge.classList.add("tile__badge", "savings");
            badge.innerHTML = `${parseInt(((tileVariant.compare_at_price - tileVariant.price) * 100) / tileVariant.compare_at_price, 10)}%${window.PXUTheme.translation.product_savings}`;
            let target = tile.querySelector(".tile__badges_container");
            if (target) {
              target.firstChild.before(badge);
            }
          }
        } else {
          compare_at_price.style.display = "none";
          savings.parentNode.style.display = "none";
          savings.innerHTML = "";
        }

        let container = tile.querySelector(".alternate_variant-price_container");
        container.style.display = "flex";
      });
    }
  }

  scrollToSection(event, target) {
    event.preventDefault();
    event.stopPropagation();
    let sectionID = target.getAttribute('data-link-to-section');
    if (!sectionID) return;
    let targetSection = null;
    let targetSectionInstance = target.hasAttribute("data-link-to-section-instance") ? Number(target.getAttribute("data-link-to-section-instance")) : 0;
    if (sectionID == "default") {
      let targetParent = $(target).closest(".shopify-section").next();
      targetSection = $(targetParent).find("section")[0];
    } else {
      targetSection = Array.from(document.querySelectorAll(`section.${sectionID}`))[targetSectionInstance];
      if (!targetSection) return;
    }
    let carousel = null;
    if (targetSection.classList.contains("Section__thumbnails-carousel")) {
      carousel = targetSection.querySelector(".swiper").swiper;
    } 
    let header = document.querySelector("#shopify-section-header-classic");
    let subheader = document.querySelector("#shopify-section-subheader-bar");
    let correction = header.clientHeight + (subheader ? subheader.clientHeight : 0);
    let targetPX = targetSection.offsetTop - header.clientHeight - (subheader ? subheader.clientHeight : 0);
    
    $(document.documentElement).animate({ scrollTop: targetPX + 'px' }, 1000, () => window.requestAnimationFrame(() => {
      if (carousel) {
        let slide = carousel.slides[2];
        slide.classList.remove("Attention");
        if(window.matchMedia("(max-width: 798px)").matches) {
          setTimeout(()=> {
            slide.classList.add("Attention");
          }, 1000);
        } else {
          void slide.offsetWidth;
          slide.classList.add("Attention");
        }
        if(window.matchMedia("(max-width: 798px)").matches) {
          carousel.slideTo(2, 1000)
        }
      }
    }));
  }

  updatePricesOnButtons() {
    let quantityInput = this._section.querySelector("input[name='quantity']");
    let quantityVal = quantityInput.value;
    let sellingPlanInput = this._section.querySelector("input[name='selling_plan']");

    let moneyFormat = $('body').data('money-format');

    const formatter = price => (
      price === 0
        ? window.PXUTheme.translation.free_price_text
        : Shopify.formatMoney(price, moneyFormat)
    );

    let priceToBePlaced;

    if (sellingPlanInput) {
      let sellingPlanID = sellingPlanInput.value;
      if (!!sellingPlanID) {
        for (let selling_plan of this.selectedVariant.selling_plan_allocations) {
          if (selling_plan.selling_plan_id == sellingPlanID) {
            priceToBePlaced = selling_plan.price;
          }
        }
      } else {
        priceToBePlaced = this.selectedVariant.price;
      }
    } else {
      priceToBePlaced = this.selectedVariant.price;
    }

    // Update variant price on "Add to Cart" Button in Tray
    if (this.tray) {
      let trayPrice = this.tray.container.querySelector(".button--add-to-cart-label-price");
      trayPrice.textContent = formatter(priceToBePlaced * quantityVal);
    }
    
    // Update variant price on "Add to Cart" Button
    let btnPrice = document.querySelector(".action_button .button--add-to-cart-label-price");
    if (btnPrice) {
      btnPrice.textContent = formatter(priceToBePlaced * quantityVal);
    }
  }

  // Subscription block
  initSubscriptionBlock() {
    //
    this.subscriptionData.elementData = this.getSubscriptionBlockData();
    this.delegateElement.on('click', "[data-purchase-type-id]", this.togglePurchaseType.bind(this));

    // Set initial value for subscription products
    let firstOption = this.subscriptionData.element.querySelector("[data-purchase-type-id]");
    let firstOptionID = firstOption.getAttribute("data-purchase-type-id");
    this.handleSubscripionCartData(firstOptionID);

    // All code goes above this
    this.subscriptionData.element.setAttribute("aria-hidden", false);
    document.querySelector('.swatch[data-bundle-option][aria-hidden=true]').setAttribute("aria-hidden", false);
  }

  getSubscriptionBlockData() {
    let $dataEl = this._section.querySelector('[data-subscription-block-data]');
    if (!$dataEl) return {}; // Load data from attribute, or innerHTML

    let data = $($dataEl).data('subscription-block-data') || $($dataEl).html();
    try {
      return JSON.parse(data);
    } catch (error) {
      console.warn(`Sections: invalid section data found. ${error.message}`);
      return {};
    }
  }

  togglePurchaseType(event, target) {
    let elements = Array.from(target.parentNode.querySelectorAll("[data-purchase-type-id]"));
    elements.forEach(button => {
      if (button === target) {
        button.classList.add("Active");
      } else {
        button.classList.remove("Active");
      }
    });
    let infos = Array.from(document.querySelectorAll("[data-purchase-type-info-id]"));
    let targetID = target.getAttribute("data-purchase-type-id")
    for (let info of infos) {
      if (info.getAttribute("data-purchase-type-info-id") === targetID) {
        $(info).fadeIn();
      } else {
        $(info).hide();
      }
    }
    
    this.handleSubscripionCartData(target.getAttribute("data-purchase-type-id"));
  }

  handleSubscripionCartData(purchaseID) {
    this.subscriptionData.purchaseID = purchaseID;
    this.subscriptionData.cartData = {
      "items": []
    };
    console.log(this.subscriptionData.elementData);
    let purchaseOption = this.subscriptionData.elementData.purchase_options[purchaseID];

    // Loop throught all product from selected Purchase Option
    for (let product of purchaseOption) {
      let variantFound = false;
      let prod = this.subscriptionData.productsFullData.find(item => item.id === product.product_id);
      
      // Skipping if product was not found
      if(prod === undefined) continue;

      // If product has only default variant
      if (prod.variants.length === 1) {
        this.subscriptionData.cartData.items.push({
          "id": prod.variants[0].id,
          "quantity": product.quantity,
          "selling_plan": product.selling_plan
        });
        continue;
      }

      // Looking fo appropriate color of subscription porduct
      for (let variant of prod.variants) {
        if (variant.option1 === this.selectedVariant.option1) {
          this.subscriptionData.cartData.items.push({
            "id": variant.id,
            "quantity": product.quantity,
            "selling_plan": product.selling_plan
          })
          variantFound = true;
          break;
        }
      }

      // Adding first available variant of subscription product
      if (!variantFound) {
        for (let variant of prod.variants) {
          if (variant.available) {
            this.subscriptionData.cartData.items.push({
              "id": variant.id,
              "quantity": product.quantity,
              "selling_plan": product.selling_plan
            });
            break;
          }
        }
      }
    }

    this.handlesubscriptionLabels();
    this.handleKlarnaPlacement();
    this.handleAdditionalPurchaseOptions();
  }

  getSubscriptionCartData() {
    let placeholder = {
      "items": []
    };
    return this.subscriptionData ? this.subscriptionData.cartData : placeholder;
  }

  handlesubscriptionLabels() {
    let subcrPriceEl = this._section.querySelector(".purchase-details--price_container--subscription_wrapper");
    let totalTextEl = document.querySelector(".purchase-details--price_container--total_wrapper--title");
    let priceElContainer = document.querySelector(".purchase-details--price_container--total_wrapper");
    let price = priceElContainer.dataset.price;
    let totalPriceEl =  this._section.querySelector(".purchase-details--price_container--total_wrapper--amount");
    let variantId = totalPriceEl.getAttribute("data-variant-id");
    let region = document.querySelector("body").dataset.selectedRegion;
    let fetchedCountry = document.querySelector("body").dataset.fetchedCountry;
    let added = 0;

    if(document.getElementById('PurchaseTypeBlock')) {
      added = 900;
      if(region == 'US') {
        added = 1198;
      }
    }

    if (!subcrPriceEl) return;

      // let checkMyInterval = setInterval(function () {
      // //Intelligems Loaded 
      // if (window.igData) {
      //   clearInterval(checkMyInterval) // Fetch prices

        const subscriptionSelected = !document.querySelector('.PurchaseTypeBlock-button.Active').classList.contains('default');
    
        if (subscriptionSelected) {
          subcrPriceEl.style.opacity = '1';
          totalTextEl.textContent = 'Your total today';
          let igPrice = (parseFloat(window.igData?.price.getPriceByVariantId(variantId))*100) || price;
          totalPriceEl.textContent = Shopify.formatMoney(parseFloat(igPrice)+added, document.body.getAttribute("data-money-format"));
        } else {
          subcrPriceEl.style.opacity = '0';
          totalTextEl.textContent = 'Your total';
          let igPrice = (parseFloat(window.igData?.price.getPriceByVariantId(variantId))*100) || price;
          totalPriceEl.textContent = Shopify.formatMoney(igPrice, document.body.getAttribute("data-money-format"));
        }
      // }
    // }, 50);
  }

  handleKlarnaPlacement() {
    let klarnaEl = this._section.querySelector("klarna-placement");
    if (!klarnaEl) return;
    if (this.subscriptionData.cartData.items.length == 0) {
      klarnaEl.classList.add('Reveal');
    } else {
      klarnaEl.classList.remove('Reveal');
    }
  }

  handleAdditionalPurchaseOptions() {
    let additionalPurchaseOptionsEl = this._section.querySelector('.purchase-details__buttons--additional');
    let region = document.querySelector("body").dataset.selectedRegion;

    if (this.subscriptionData.cartData.items.length == 0) {
      additionalPurchaseOptionsEl.classList.remove('hidden');
    } else if(region == 'GB') {
      additionalPurchaseOptionsEl.classList.add('hidden');
    }
  }

  addTestStyle(href) {
    let link = document.createElement( "link" );
    link.href = href;
    link.type = "text/css";
    link.rel = "stylesheet";
    link.media = "all";
    document.getElementsByTagName("head")[0].appendChild(link);
  }

  handleVariantImageSelection2(variant, initial, product) {
    if (!variant) return;
    let mainGallery = this._section.querySelector(".product-gallery__main");
    let mainGalleryImages = mainGallery.querySelectorAll(".product-gallery__image");

    // Create temporary element to work with cells
    let temp_images_element = document.createElement("div");
    temp_images_element.innerHTML = this._data.all_images_html;

    const alt = variant.option1.replace(' ', '-').toLowerCase();

    let targetImages = Array.from(temp_images_element.querySelectorAll(`[data-variant-name='xs:${alt}']`));
    targetImages = targetImages.filter(image => {
      for (let variant2 of product.variants) {
        if(variant2.featured_image) {
          if (image.dataset.mediaId == variant2.featured_media.id && variant.id != variant2.id) {
            return false;
          }
        }
      }
      return true;
    });

    mainGallery.innerHTML = '';
    targetImages.forEach((item, index) => {
      if (this.queryParams.get("quotes") === "true") {
        mainGallery.appendChild(this.addQuoteToImage(item, index))
      } else {
        mainGallery.appendChild(item)
      }
    });

    mainGallery.classList.add("loaded");

    let gallery = $(this._section).find('.product-gallery__main');
  }

  addFullGalleryButton() {
    let targetContainer = this._section.querySelector(".product-gallery");
    let imagesContainer = this._section.querySelector(".product-gallery__main");
    let button = document.createElement("button");
    button.id = "ShowFullGallery";
    // button.style.display = "none";
    button.classList.add("button", "button--secondary");
    let icon = "<svg width=\"12\" height=\"11\" viewBox=\"0 0 12 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0.916992 5.87963V5.14363H5.63199V0.244629H6.36799V5.14363H11.083V5.87963H6.36799V10.7556H5.63199V5.87963H0.916992Z\"/></svg>";
    let button_text = document.createElement("span");
    button_text.textContent = "Show full gallery";
    button.innerHTML = icon;
    button.appendChild(button_text);
    targetContainer.setAttribute("aria-expanded", false)
    targetContainer.appendChild(button);
    this.delegateElement.on('click', "#ShowFullGallery", this.expandGallery);
  }

  expandGallery(event, target) {
    let imagesContainer = target.parentNode.querySelector(".product-gallery__main");
    let images = Array.from(imagesContainer.querySelectorAll(".product-gallery__image:nth-child(n+4)"));
    images.forEach(image => {
      let imageEL = image.querySelector("img.lazyload");
      lazySizes.loader.unveil(imageEL);
    });
    $(target).hide();

    function slideDownImages(images) {
      $([images[0], images[1]]).slideDown("linear",function(){
        let newImages = images.slice(2);
        if (newImages.length > 0) {
          slideDownImages(newImages);
        }
      });
    }
    slideDownImages(images);
    target.parentNode.setAttribute("aria-expanded", true);
    target.remove();
  }

  initSelectionSteps() {
    if(!document.querySelector('.product-presel')){
      let elements = this._section.querySelectorAll("[data-selection-step=false]");
      let [firstElement, ...other] = [...elements];
      firstElement.setAttribute("data-selection", "");
      other.forEach( element => {
        if(!document.querySelector('.product-nogrey')){
          element.style.opacity = "0.2";
        }
      });
    }
    this.delegateElement.on("click", ".PurchaseTypeBlock-button, .swatch__option, button.ajax-submit", this.handleSelectionSteps.bind(this));
    this.updateTrayButton();
  }

  handleSelectionSteps(event, target) {
    console.log('Handling');
    // Disable case only option
    if(target.classList.contains("colour")) {
      if(document.querySelector('.product__images fieldset.swatch')) {
        const gallerySwatch = document.querySelector('.product__images fieldset.swatch');
        const labelFor = target.querySelector('label').getAttribute('for');

        // Remove active class
        if(document.querySelector('.image-gallery_labels.active')){
          document.querySelector('.image-gallery_labels.active').classList.remove('active'); 
        }
        // Set active class
        if(document.querySelector(`.image-gallery_labels[for="${labelFor}"]`)) {
          document.querySelector(`.image-gallery_labels[for="${labelFor}"]`).classList.add('active');
        }
      }
    }

    // fix weird behaviour with second click event
    if (event.pointerType === "") return;
    
    let targetElement = target.closest("[data-selection-step]");
    let elements = Array.from(this._section.querySelectorAll("[data-selection-step]"));
    let targetIndex = elements.indexOf(targetElement);
    
    if(targetElement !== null) {
      if (targetElement.getAttribute("data-selection-step") === "true") return;
    }

    if(document.querySelector('.product__signup-form')) {
      document.querySelector('.product__signup-form').classList.add('hidden');
      document.querySelector('.product__signup-form').classList.remove('active');
    }

    if(document.getElementById('PurchaseTypeBlock')) {
      if(document.getElementById('PurchaseTypeBlock').classList.contains('shrunk')) {
        document.getElementById('PurchaseTypeBlock').classList.remove("shrunk");
        document.getElementById('PurchaseTypeBlock').setAttribute("aria-hidden", "false");
        document.querySelector('.purchase-details').classList.remove('hidden');
      }
    }

    // Check if user can interact with container
    if(targetElement !== null) {
      if (targetElement.hasAttribute("data-selection")) {

        // Activate target container
        targetElement.removeAttribute("data-selection");
        targetElement.setAttribute("data-selection-step", "true");

        // Enable next step
        if (elements[targetIndex+1]) {
          elements[targetIndex+1].setAttribute("data-selection", "");
          elements[targetIndex+1].style.opacity = "1";
          elements[targetIndex+1].style.maxHeight = "1000px";
          elements[targetIndex+1].style.overflow = "visible";
          // If next step is last step - activate it
          if (elements[targetIndex+1] === elements[elements.length-1]) {
            elements[targetIndex+1].setAttribute("data-selection-step", "true");
            if(this.tray.button) {
              this.tray.button.classList.add("ajax-submit");
              window.PXUTheme.jsCart.watchLegacyAtcButtons();
            }
          }
        }
        // Hide "from ..." in the price
        if (targetIndex >= 1) {
          let prictFromEl = this._section.querySelector("span.from_text");
          prictFromEl.style.display = "none";
        }
      } else {
        event.preventDefault();
        event.stopPropagation();

        let targetEl = document.querySelector("[data-selection]");
        targetEl.classList.remove("Attention");

        // if (window.PXUTheme.media_queries.medium.matches) {
          let header = document.querySelector("#shopify-section-header-classic");
          let subheader = document.querySelector("#shopify-section-subheader-bar");
          let targetPX = window.scrollY + targetEl.getBoundingClientRect().top - header.clientHeight - (subheader ? subheader.clientHeight : 0) - 20;
          $("html, body").animate({ scrollTop: targetPX + 'px' }, 400, () => window.requestAnimationFrame(function(){targetEl.classList.add("Attention")}));
        // } else {
        //   setTimeout(() => window.requestAnimationFrame(function(){targetEl.classList.add("Attention")}), 10);
        // } 
      }
    }
    
    this.updateTrayVariantLabels();
    this.updateTrayButton();
  }

  replaceCollapsibleTabs() {
    let tabs = this._section.querySelector(".collapsible_block[data-layout='Mobile']");
    let targetEl = Array.from(document.querySelectorAll(".jsThumbnailsCarousel")).slice(-1);
    if (targetEl === undefined || targetEl.length == 0) return;
    let targetContainer = targetEl[0].querySelector(".Section__thumbnails-carousel");
    $(tabs).appendTo(targetContainer);
  }

  addQuoteToImage(imageContainer, index) {
    let quote = this.imageQuotes[index];
    if (quote === undefined || quote === "Empty") return imageContainer;
    let textEl = document.createElement("p");
    textEl.classList.add("product-gallery__image--text");
    textEl.textContent = quote;
    imageContainer.firstChild.before(textEl);
    return imageContainer;
  }

  hideFormIcons() {
    let targetContainer = this._section.querySelector(".product_form--icons");
    targetContainer.style.display = "none";
  }

}


window.PXUTheme.jsProductClass = Product;
window.PXUTheme.jsProduct = {
  init($section) {
    window.PXUTheme.productSectionInstance = new Product($section);
    return window.PXUTheme.test;
  },
  showThemeEditorState: function(id, $section) {
    let floatingButton = $section[0].querySelector(".form__floating-button");
    if (floatingButton) {
      floatingButton.setAttribute("aria-hidden", false);
    }
  },
  hideThemeEditorState: function(id, $section) {
    let floatingButton = $section[0].querySelector(".form__floating-button");
    if (floatingButton) {
      floatingButton.setAttribute("aria-hidden", true);
    }
  },
  relatedProducts() {
    $('.js-related-products-slider .products-slider').each((_, slider) => {

      const $relatedSlider = $(slider);

      const slideData = {
        products_per_slide: $relatedSlider.data('products-per-slide'),
        products_available: $relatedSlider.data('products-available'),
        products_limit: $relatedSlider.data('products-limit'),
        initialIndex: 0,
        cellAlign: 'left',
        wrapAround: true,
      };

      if (
        slideData.products_available > slideData.products_per_slide
        && slideData.products_limit > slideData.products_per_slide
      ) {
        slideData.wrapAround = true;
      } else {
        slideData.wrapAround = false;
      }

      if (
        slideData.products_available < slideData.products_per_slide
        || slideData.products_limit < slideData.products_per_slide
      ) {
        $relatedSlider.addClass('container is-justify-center');
        $relatedSlider.find('.gallery-cell').addClass('column');
      } else {
        $relatedSlider.flickity({
          lazyLoad: 5,
          freeScroll: true,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'center',
          wrapAround: slideData.wrapAround,
          pageDots: false,
          contain: true,
          prevNextButtons: slideData.products_limit > slideData.products_per_slide,
          initialIndex: slideData.initialIndex,
          arrowShape: window.arrowShape,
        });

        // Resize flickity when the slider is settled
        $relatedSlider.on('settle.flickity', () => $relatedSlider.flickity('resize'));

        $(window).on('load', () => $relatedSlider.flickity('resize'));
      }
    });
  },
};



document.addEventListener('DOMContentLoaded', function () {
  let elements = document.querySelectorAll('[data-selection-step]:not(.purchase-details)');

  elements.forEach((element, index) => {

    const observer = new MutationObserver(() => {
      // if (element.getAttribute('data-selection-step') === 'true' && index < elements.length - 1) {
      //   elements[index + 1].style.maxHeight = '1000px';
      // }
    });

    observer.observe(element, {
      attributes: true,
      attributeFilter: ['data-selection-step']
    });
  });
});



/******/ })()
;